// extracted by mini-css-extract-plugin
module.exports = {"container":"exo-iris_container__iTPt6","placeholder":"exo-iris_placeholder__GRWuc","h2":"exo-iris_h2__RPzVu","modularSectionsTop":"exo-iris_modularSectionsTop__489vk"};